
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[[...option]]",
      function () {
        return require("private-next-pages/search/[[...option]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[[...option]]"])
      });
    }
  